module.exports = new __parcel__URL__("cleverpenman-transparent.d879d2a2.webp").toString();